/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParsedFieldString
 */
export interface ParsedFieldString {
    /**
     * 
     * @type {string}
     * @memberof ParsedFieldString
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParsedFieldString
     */
    hasParseErrors?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParsedFieldString
     */
    parseErrors?: Array<string>;
}

/**
 * Check if a given object implements the ParsedFieldString interface.
 */
export function instanceOfParsedFieldString(value: object): value is ParsedFieldString {
    return true;
}

export function ParsedFieldStringFromJSON(json: any): ParsedFieldString {
    return ParsedFieldStringFromJSONTyped(json, false);
}

export function ParsedFieldStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedFieldString {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'hasParseErrors': json['hasParseErrors'] == null ? undefined : json['hasParseErrors'],
        'parseErrors': json['parseErrors'] == null ? undefined : json['parseErrors'],
    };
}

export function ParsedFieldStringToJSON(value?: ParsedFieldString | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'hasParseErrors': value['hasParseErrors'],
        'parseErrors': value['parseErrors'],
    };
}

